import { addMessages } from '@hana/i18n';

// Khoá chuỗi của chi tiết tuyến (LaneDetail.tsx). Mã tuyến / cảng / hãng / service, nhãn nhóm vùng (costRates.ts) và nhãn ô lịch (lts.ts) không dịch.
addMessages('vi', {
  'ld.stOk': 'Còn hạn',
  'ld.stSoon': 'Sắp hết ≤ 7 ngày',
  'ld.stExp': 'Có hãng hết hạn',
  'ld.stNone': 'Chưa có giá',
  'ld.fold': 'Mở hoặc gập {v}',
  'ld.foldTip': 'Mở / gập',
  'ld.moreAct': 'Thao tác với tuyến',
  'ld.mAssign': 'Gán người phụ trách Pricing',
  'ld.mUnfollow': 'Bỏ Follow tuyến',
  'ld.mMerge': 'Gộp vào tuyến khác',
  'ld.mExport': 'Xuất tuyến này',
  'ld.mRemind': 'Gửi nhắc gia hạn giá',
  'ld.mEdit': 'Sửa tuyến',
  'ld.mStop': 'Ngừng theo dõi tuyến',
  'ld.mInquiry': 'Hỏi giá đối tác',
  'ld.mRates': 'Mở Freight Cost',
  'ld.noWrite': 'Chưa bật ghi Services Map',
  'ld.svcHub': 'Nối chuyến chuyển tải · chưa có service đi thẳng',
  'ld.svcNone': 'Service chưa khai ở lịch hãng',
  'ld.tAssign': 'Giao Pricing phụ trách',
  'ld.tAssignSub': 'tuyến chưa có người nhận hỏi giá / nhắc gia hạn',
  'ld.assign': 'Giao',
  'ld.tRenew': 'Gia hạn giá · {n} hãng',
  'ld.expN': '{n} hết giá',
  'ld.soonN': '{n} sắp hết',
  'ld.remindBefore': 'nhắc trước {n} ngày',
  'ld.remind': 'Nhắc',
  'ld.tPending': '{n} hỏi giá đang chờ đối tác',
  'ld.tPendingSub': 'Hỏi giá đối tác · nhắc đối tác chưa trả lời',
  'ld.open': 'Mở',
  'ld.tNoRate': 'Tuyến chưa có giá hãng',
  'ld.tNoRateSub': 'nhập giá mua đầu tiên ở Freight Cost',
  'ld.enter': 'Nhập giá',
  'ld.tValid': '{n} hãng còn hạn giá',
  'ld.earliest': 'hết sớm nhất {v}',
  'ld.enough': 'đủ hạn',
  'ld.iCode': 'Mã tuyến',
  'ld.iLane': 'Tuyến',
  'ld.iGroup': 'Nhóm',
  'ld.iTs': 'Chuyển tải',
  'ld.direct': 'Đi thẳng',
  'ld.days': '{n} ngày',
  'ld.iFreq': 'Tần suất',
  'ld.perWeekN': '{n} chuyến / tuần',
  'ld.carrier': 'Hãng',
  'ld.lCost': 'Freight Cost · giá mua',
  'ld.lLookup': 'Tra Giá và Lịch tuyến này',
  'ld.lInq': 'Hỏi giá đối tác',
  'ld.lQuote': 'Báo giá trên tuyến',
  'ld.lJob': 'Job trên tuyến',
  'ld.look': 'Tra',
  'ld.aLook': 'Tra',
  'ld.aLookTip': 'Lượt tra Giá và Lịch · Sale và CS',
  'ld.aInq': 'Hỏi giá',
  'ld.aInqWait': 'Hỏi giá · {n} đang chờ đối tác',
  'ld.aInqDone': 'Hỏi giá · đã trả hết',
  'ld.aQuote': 'Báo giá',
  'ld.aQuoteTip': 'Báo giá đã gửi khách',
  'ld.aJobTip': 'Job đã nhận booking',
  'ld.back': 'Quay lại danh sách tuyến',
  'ld.laneAria': 'Tuyến {a} đến {b}',
  'ld.priceDot': 'Giá: {d} · {a}/{b} hãng còn giá',
  'ld.unfollow': 'Bỏ Follow tuyến',
  'ld.follow': 'Follow tuyến',
  'ld.picIs': 'Pricing: {v}',
  'ld.picNone': 'Chưa giao Pricing',
  'ld.map': 'Bản đồ tuyến',
  'ld.mapTip': 'POL → POD · mỗi service một màu · vòng tròn = cảng chuyển tải. Bấm mã service để làm nổi dòng.',
  'ld.mapSum': 'Bản đồ tuyến {a} → {b} · {n} service',
  'ld.pPol': 'cảng đi',
  'ld.pPod': 'cảng đến',
  'ld.pHub': 'cảng chuyển tải',
  'ld.pCall': 'cảng ghé',
  'ld.svcBelow': 'Service {v} · xem dòng bên dưới',
  'ld.noCoord': 'Chưa có toạ độ cảng cho tuyến này',
  'ld.freqWeek': '{n} /tuần',
  'ld.vnPort': 'Cảng VN',
  'ld.carSvc': 'Hãng và service',
  'ld.carSvcTip': 'Bấm dòng để làm nổi service trên bản đồ.',
  'ld.svcN': '{n} service',
  'ld.ttDays': 'T/T (ngày)',
  'ld.perWeek': '/tuần',
  'ld.dotTip': 'Đi thẳng (chấm đặc) · chuyển tải (vòng cam)',
  'ld.pickOnMap': 'Chọn service {v} trên bản đồ',
  'ld.tsVia': 'Chuyển tải {v}',
  'ld.sched': 'Lịch tàu sắp tới',
  'ld.schedTip': 'Dải tuần · mỗi ô một chuyến theo service. Bấm ô để mở Giá và Lịch › Lịch tàu.',
  'ld.schedSum': 'Lịch tàu theo tuần · {n} service',
  'ld.pick': 'Chọn service {v}',
  'ld.noData': 'chưa có dữ liệu',
  'ld.openSched': 'mở Lịch tàu',
  'ld.end': 'Hết',
  'ld.activity': 'Hoạt động',
  'ld.activityTip': '30 ngày · đếm số lượt tra, hỏi giá, báo giá, job · không kèm tiền.',
  'ld.in30': '{tip} · {v} trong 30 ngày',
  'ld.todo': 'Việc cần làm',
  'ld.todoTip': 'Việc từ giá và cài đặt tuyến: chưa giao Pricing, giá sắp hết / hết hạn, hỏi giá đang chờ đối tác, tuyến chưa có giá.',
  'ld.todoN': '{n} việc cần làm',
  'ld.noTodo': 'Không còn việc',
  'ld.noTodoLi': 'Không còn việc nào.',
  'ld.mainInfo': 'Thông tin chính',
  'ld.mainInfoTip': 'Mã tuyến {c} · {r} · loại hàng DC · RF',
  'ld.prices': 'Giá hiện có',
  'ld.pricesTip': 'Hiệu lực giá mua theo hãng. Giá mua chỉ hiện ở Freight Cost cho người có quyền tiền.',
  'ld.pricesSum': '{a} còn hạn · {b} sắp hết · {c} hết giá / {d} hãng',
  'ld.validity': 'Hiệu lực',
  'ld.left': 'còn',
  'ld.validRange': 'hiệu lực {a} – {b}',
  'ld.expiredShort': 'hết',
  'ld.moreCars': '+{n} hãng',
  'ld.owner': 'Người phụ trách và cài đặt',
  'ld.ownerTip': 'PIC Pricing nhận hỏi giá và nhắc gia hạn của tuyến · Follow đưa tuyến lên lưới Freight Cost · nhắc trước khi giá hết.',
  'ld.unassigned': 'chưa giao',
  'ld.noFollow': 'không Follow',
  'ld.ownerSum': 'PIC {p} · {f} · nhắc trước {n} ngày',
  'ld.picTip': 'Người phụ trách Pricing · nhận hỏi giá và nhắc gia hạn của tuyến',
  'ld.picGroup': 'Người phụ trách Pricing',
  'ld.pricingP': 'Pricing {v}',
  'ld.followTip': 'Cờ trọng điểm · lên lưới Hãng × Tuyến ở Freight Cost, đầu danh sách và Tra Giá và Lịch',
  'ld.remindLabel': 'Nhắc trước',
  'ld.remindTip': 'Nhắc người phụ trách Pricing khi giá của một hãng sắp hết · mặc định 7 ngày',
  'ld.remindGroup': 'Nhắc gia hạn trước',
  'ld.links': 'Liên kết',
  'ld.linksTip': 'Mở nhanh các màn liên quan tới tuyến này.',
  'ld.linksSum': '{n} màn liên quan',
});
addMessages('en', {
  'ld.stOk': 'Valid',
  'ld.stSoon': 'Expiring ≤ 7 days',
  'ld.stExp': 'Some carriers expired',
  'ld.stNone': 'No rate',
  'ld.fold': 'Expand or collapse {v}',
  'ld.foldTip': 'Expand / collapse',
  'ld.moreAct': 'Lane actions',
  'ld.mAssign': 'Assign Pricing owner',
  'ld.mUnfollow': 'Unfollow lane',
  'ld.mMerge': 'Merge into another lane',
  'ld.mExport': 'Export this lane',
  'ld.mRemind': 'Remind rate renewal',
  'ld.mEdit': 'Edit lane',
  'ld.mStop': 'Stop following lane',
  'ld.mInquiry': 'Partner rate inquiry',
  'ld.mRates': 'Open Freight Cost',
  'ld.noWrite': 'Writing Services Map is not enabled',
  'ld.svcHub': 'Transshipment connection · no direct service yet',
  'ld.svcNone': 'Service not declared in the carrier schedule',
  'ld.tAssign': 'Assign a Pricing owner',
  'ld.tAssignSub': 'no one receives rate inquiries / renewal reminders for this lane',
  'ld.assign': 'Assign',
  'ld.tRenew': 'Renew rates · {n} carriers',
  'ld.expN': '{n} expired',
  'ld.soonN': '{n} expiring',
  'ld.remindBefore': 'remind {n} days before',
  'ld.remind': 'Remind',
  'ld.tPending': '{n} rate inquiries waiting for partners',
  'ld.tPendingSub': 'Partner inquiries · remind partners who have not replied',
  'ld.open': 'Open',
  'ld.tNoRate': 'Lane has no carrier rate',
  'ld.tNoRateSub': 'enter the first buy rate in Freight Cost',
  'ld.enter': 'Enter rate',
  'ld.tValid': '{n} carriers with valid rates',
  'ld.earliest': 'earliest expiry {v}',
  'ld.enough': 'enough validity',
  'ld.iCode': 'Lane code',
  'ld.iLane': 'Lane',
  'ld.iGroup': 'Group',
  'ld.iTs': 'Transshipment',
  'ld.direct': 'Direct',
  'ld.days': '{n} days',
  'ld.iFreq': 'Frequency',
  'ld.perWeekN': '{n} sailings / week',
  'ld.carrier': 'Carrier',
  'ld.lCost': 'Freight Cost · buy rates',
  'ld.lLookup': 'Look up Rates & Schedules for this lane',
  'ld.lInq': 'Partner rate inquiries',
  'ld.lQuote': 'Quotes on this lane',
  'ld.lJob': 'Jobs on this lane',
  'ld.look': 'Look up',
  'ld.aLook': 'Lookups',
  'ld.aLookTip': 'Rates & Schedules lookups · Sales and CS',
  'ld.aInq': 'Inquiries',
  'ld.aInqWait': 'Inquiries · {n} waiting for partners',
  'ld.aInqDone': 'Inquiries · all answered',
  'ld.aQuote': 'Quotes',
  'ld.aQuoteTip': 'Quotes sent to customers',
  'ld.aJobTip': 'Jobs with a booking',
  'ld.back': 'Back to lane list',
  'ld.laneAria': 'Lane {a} to {b}',
  'ld.priceDot': 'Rate: {d} · {a}/{b} carriers with rates',
  'ld.unfollow': 'Unfollow lane',
  'ld.follow': 'Follow lane',
  'ld.picIs': 'Pricing: {v}',
  'ld.picNone': 'No Pricing owner',
  'ld.map': 'Lane map',
  'ld.mapTip': 'POL → POD · one colour per service · circle = transshipment port. Click a service code to highlight its row.',
  'ld.mapSum': 'Lane map {a} → {b} · {n} services',
  'ld.pPol': 'port of loading',
  'ld.pPod': 'port of discharge',
  'ld.pHub': 'transshipment port',
  'ld.pCall': 'port of call',
  'ld.svcBelow': 'Service {v} · see the row below',
  'ld.noCoord': 'No port coordinates for this lane',
  'ld.freqWeek': '{n} /week',
  'ld.vnPort': 'VN port',
  'ld.carSvc': 'Carriers and services',
  'ld.carSvcTip': 'Click a row to highlight the service on the map.',
  'ld.svcN': '{n} services',
  'ld.ttDays': 'T/T (days)',
  'ld.perWeek': '/week',
  'ld.dotTip': 'Direct (solid dot) · transshipment (orange ring)',
  'ld.pickOnMap': 'Select service {v} on the map',
  'ld.tsVia': 'Transshipment {v}',
  'ld.sched': 'Upcoming sailings',
  'ld.schedTip': 'Week strip · one cell per sailing by service. Click a cell to open Rates & Schedules › Sailings.',
  'ld.schedSum': 'Sailings by week · {n} services',
  'ld.pick': 'Select service {v}',
  'ld.noData': 'no data',
  'ld.openSched': 'open Sailings',
  'ld.end': 'End',
  'ld.activity': 'Activity',
  'ld.activityTip': '30 days · counts of lookups, inquiries, quotes, jobs · no money',
  'ld.in30': '{tip} · {v} in 30 days',
  'ld.todo': 'To do',
  'ld.todoTip': 'Tasks from rates and lane settings: no Pricing owner, rates expiring / expired, inquiries waiting for partners, lane without rates.',
  'ld.todoN': '{n} tasks',
  'ld.noTodo': 'Nothing left',
  'ld.noTodoLi': 'No tasks left.',
  'ld.mainInfo': 'Main information',
  'ld.mainInfoTip': 'Lane code {c} · {r} · cargo DC · RF',
  'ld.prices': 'Current rates',
  'ld.pricesTip': 'Buy-rate validity by carrier. Buy rates are only shown in Freight Cost to people with money permission.',
  'ld.pricesSum': '{a} valid · {b} expiring · {c} expired / {d} carriers',
  'ld.validity': 'Validity',
  'ld.left': 'left',
  'ld.validRange': 'valid {a} – {b}',
  'ld.expiredShort': 'exp.',
  'ld.moreCars': '+{n} carriers',
  'ld.owner': 'Owner and settings',
  'ld.ownerTip': 'Pricing PIC receives rate inquiries and renewal reminders for the lane · Follow puts the lane on the Freight Cost grid · remind before rates expire.',
  'ld.unassigned': 'unassigned',
  'ld.noFollow': 'not followed',
  'ld.ownerSum': 'PIC {p} · {f} · remind {n} days before',
  'ld.picTip': 'Pricing owner · receives rate inquiries and renewal reminders for the lane',
  'ld.picGroup': 'Pricing owner',
  'ld.pricingP': 'Pricing {v}',
  'ld.followTip': 'Priority flag · appears on the Carrier × Lane grid in Freight Cost, at the top of lists and in Rates & Schedules',
  'ld.remindLabel': 'Remind before',
  'ld.remindTip': 'Remind the Pricing owner when a carrier rate is about to expire · default 7 days',
  'ld.remindGroup': 'Renewal reminder lead time',
  'ld.links': 'Links',
  'ld.linksTip': 'Quick links to related screens.',
  'ld.linksSum': '{n} related screens',
});
